export enum PermissionTarget {
	// Static data
	STATIC_BRAND = "static.brand",
	STATIC_COUNTRY = "static.country",
	STATIC_LOCALE = "static.locale",
	STATIC_LOCALIZATION = "static.localization",

	// Global entities
	COMPANY = "company",
	MOVIE = "movie",
	PERSON = "person",
	SERIES = "series",
	THEATER = "theater",
	THEATER_EVENT = "theater_event",
	FESTIVAL = "festival",

	// Entity global permissions
	ENTITY_DELETION = "entity.delete",

	// Entity overrides
	ENTITY_BRAND_DATA = "entity.brand_data",
	ENTITY_LOCALE_DATA = "entity.locale_data",
	ENTITY_SEO_DATA = "entity.seo_data",
	ENTITY_RELEASES = "entity.releases",

	// Events
	ENTITY_CHANGE_EVENT = "entity.change_event",

	// Branded entities
	BRAND_AUTHOR = "brand.author",
	BRAND_CAROUSEL = "brand.carousel",
	BRAND_EDITORIAL_REVIEW = "brand.editorial_review",
	BRAND_SPECIAL_OPERATION = "brand.special_operation",
	BRAND_NEWS = "brand.news",
	BRAND_PRESS_REVIEW = "brand.press_review",
	BRAND_TAG = "brand.tag",
	BRAND_TRIVIA = "brand.trivia",
	BRAND_SEARCH_LINK = "brand.search_link",
	BRAND_REDIRECTION_RULE = "brand.redirection_rule",

	// Media
	MEDIA_IMAGE = "media.image",
	MEDIA_VIDEO = "media.video",

	// Misc
	BOXOFFICE = "boxoffice",
	DUPLICATE = "duplicate",
	PRODUCT_MATCHING = "product.matching",
	PRODUCT = "product",

	// Social
	SOCIAL_USER = "social.user",
	SOCIAL_USER_REVIEW = "social.user_review",
	SOCIAL_USER_IMAGES_CATEGORIES = "social.user_images_categories",

	// Khronos
	KHRONOS_IMPORT_CRAWLER = "khronos.import_crawler",
	KHRONOS_IMPORT_CONFIGURATION = "khronos.import_configuration",
	KHRONOS_IMPORT_RUN = "khronos.import_run",
	KHRONOS_SHOWTIME = "khronos.showtime",
	KHRONOS_TRIGGER_ALL = "khronos.trigger_all",

	// Showtimes
	SHOWTIME_CLOCK = "showtime.clock",
	SHOWTIME_MATCHING = "showtime.matching",
	SHOWTIME_MATCHING_IGNORE_ALL_MATCHERS = "showtime.matching.ignore_all_matchers",

	// Graph API & Proxy
	GRAPH_API_APPLICATION = "graph_api.application",
	GRAPH_API_TOKEN = "graph_api.token",
	GRAPH_API_PROXY = "graph_api.proxy",

	// Jump platform
	JUMP_PLATFORM_GENERATE_LINK = "jump_platform.generate_link",

	// Security
	SECURITY_PRESET = "security.preset",
	SECURITY_USER = "security.user",

	// Person
	PERSON_LINK_TAGS = "person.link_tags",

	// Import wizard
	IMPORT_WIZARD_ACCESS = "import_wizard.access",
	IMPORT_WIZARD_DASHBOARD = "import_wizard.dashboard",
	IMPORT_WIZARD_CASTING_TMDB = "import_wizard.casting.tmdb",
	IMPORT_WIZARD_CASTING_OMDB = "import_wizard.casting.omdb",
	IMPORT_WIZARD_CASTING_WIKIPEDIA = "import_wizard.casting.wikipedia",
	IMPORT_WIZARD_CASTING_IMAGE = "import_wizard.casting.image",
	IMPORT_WIZARD_CASTING_TEXT = "import_wizard.casting.text",
	IMPORT_WIZARD_CASTING_PDF = "import_wizard.casting.pdf",
	IMPORT_WIZARD_CREDITS_TMDB = "import_wizard.credits.tmdb",
	IMPORT_WIZARD_CREDITS_OMDB = "import_wizard.credits.omdb",
	IMPORT_WIZARD_CREDITS_WIKIPEDIA = "import_wizard.credits.wikipedia",
	IMPORT_WIZARD_CREDITS_IMAGE = "import_wizard.credits.image",
	IMPORT_WIZARD_CREDITS_TEXT = "import_wizard.credits.text",
	IMPORT_WIZARD_CREDITS_PDF = "import_wizard.credits.pdf",
	IMPORT_WIZARD_PERSON_TMDB = "import_wizard.person.tmdb",
	IMPORT_WIZARD_PERSON_WIKIMEDIA_COMMONS = "import_wizard.person.wikimedia_commons",
	IMPORT_WIZARD_PERSON_WIKIDATA = "import_wizard.person.wikidata",
	IMPORT_WIZARD_PERSON_BESTIMAGE = "import_wizard.person.bestimage",

	// Movie
	MOVIE_BRANDED_CONTENT = "movie.branded_content",
	MOVIE_CLUB = "movie.club",
	MOVIE_CONNECTION = "movie.connection",
	MOVIE_LINK_TAGS = "movie.link_tags",
	MOVIE_SHOWTIMES_EMBARGOS = "movie.showtimes_embargos",
	MOVIE_BRANDED_DATA_COPY_TO_LOCALE_DATA = "movie.branded_data.copy_to_locale_data",
	MOVIE_BRANDED_DATA_RULING = "movie.branded_data.ruling",

	// Series
	SERIES_LINK_TAGS = "series.link_tags",
	SERIES_SEASON_DELETE = "series_season.delete",
	SERIES_EPISODE_DELETE = "series_episode.delete",
	SERIES_BRANDED_DATA_RULING = "series.branded_data.ruling",
	SERIES_CLUB = "series.club",

	// News
	NEWS_LINK_TAGS = "news.link_tags",

	// Widget
	WIDGET = "secure.widget",

	// Ratings
	CONFIGURATION_RATINGS = "configuration.ratings",

	// AI
	CAN_USE_AI_GENERATION = "ai.generation",
}
